import * as XLSX from 'xlsx';

export const jobQuestionsparseExcelToJson = async (file) => {
  const readExcelFile = () =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        resolve(json);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });

  const rawData = await readExcelFile();

  if (!rawData.length) {
    throw new Error("The file is empty or uploaded irrelevant file.");
  }

  const requiredHeaders = [
    'Passage-Title',
    'Passage-Content',
    'Question',
    'Answer-Type',
    'Options',
    'Correct-Answer',
    'Time-Limit-Seconds',
    'Stage'
  ];

  const fileHeaders = Object.keys(rawData[0]);

  const missingHeaders = requiredHeaders.filter(header => !fileHeaders.includes(header));
  if (missingHeaders.length > 0) {
    throw new Error(`Missing required headers: ${missingHeaders.join(', ')}`);
  }

  const passageMap = new Map();
  let passageId = 1;
  let questionId = 1;

  const passage_questions = [];
  const additional_questions = [];

  rawData.forEach((row) => {
    const passageTitle = row['Passage-Title']?.trim() || '';
    const passageContent = row['Passage-Content']?.trim() || '';

    let currentPassageId = null;

    if (passageTitle) {
      const key = `${passageTitle}|${passageContent}`;
      if (!passageMap.has(key)) {
        passageMap.set(key, passageId);
        passage_questions.push({
          id: passageId,
          title: passageTitle,
          content: passageContent,
        });
        passageId++;
      }
      currentPassageId = passageMap.get(key);
    }

    let answerType = (row['Answer-Type']).toLowerCase();
    if (answerType === 'text') {
      answerType = 'varchar';
    }

    let correctAnswer = String(row['Correct-Answer']).trim();
    let options = null;

    if (answerType === 'mcq' && row['Options']) {
      if (typeof row['Options'] === 'string') {
        const optionsArray = row['Options'].split(',').map(opt => opt.trim());
        options = JSON.stringify(optionsArray);
        if (correctAnswer) {
          const matchingOption = optionsArray.find(opt => opt === correctAnswer);
          if (matchingOption) {
            correctAnswer = matchingOption;
          } else {
            console.warn(`Correct-Answer "${correctAnswer}" for question "${row['Question']}" does not match any options. Setting to empty string.`);
            correctAnswer = '';
          }
        }
      } else {
        options = JSON.stringify(row['Options']);
      }
    } else if (answerType === 'boolean') {
      const normalizedAnswer = correctAnswer.toLowerCase();
      if (['true', 'false'].includes(normalizedAnswer)) {
        correctAnswer = normalizedAnswer;
      } else {
        console.warn(`Correct-Answer "${correctAnswer}" for boolean question "${row['Question']}" is invalid. Setting to empty string.`);
        correctAnswer = '';
      }
    }

    const stage = answerType === 'url' ? 2 : 1;

    let isJustified = false;
    if (['boolean', 'mcq'].includes(answerType)) {
      if ('Need-To-Be-Justified' in row && row['Need-To-Be-Justified'] !== '') {
        isJustified = String(row['Need-To-Be-Justified']).toLowerCase() === 'true';
      }
    }

    additional_questions.push({
      id: questionId++,
      question: row['Question'],
      answer_type: answerType,
      options,
      correct_answer: correctAnswer || '',
      time_limit_seconds: String(row['Time-Limit-Seconds'] || ''),
      stage,
      passage_id: currentPassageId,
      is_active: true,
      has_image: false,
      image: null,
      imageName: "",
      is_justified: isJustified
    });
  });

  return {
    passage_questions,
    additional_questions,
  };
};